import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import { locations_api, location_api } from "../../../config/api";
import { defaultOpt } from "../../../config/map";
import { isInRange } from "../functions/map";
import { filterHours, filterByMeta } from "../functions/filters";
import { setStateFromLocalStore, saveStateToLocalStore, resetLocalStore } from "./localStore";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        distance: "all",
        filters: {
            hours: null,
            meta: null
        },
        locations: [],
        isInitializing: true,
        isLoading: true,
        selectedLocation: null,
        isSpecificLocation: false,
        userLocation: {},
        userSearch: {},
    },
    mutations: {
        SET_FILTERS(state, location) {
            state.filters.hours = location.hours;
            state.filters.meta = location.meta;
            saveStateToLocalStore("hours", location.hours);
            saveStateToLocalStore("meta", location.meta);
        },
        SET_INITIALIZING(state, isInitializing) {
            state.isInitializing = isInitializing;
        },
        SET_LOADING(state, isLoading) {
            state.isLoading = isLoading;
        },
        SET_LOCATIONS(state, locations) {
            state.locations = locations;
        },
        SET_SELECTED_LOCATION(state, location) {
            state.selectedLocation = location;
        },
        SET_SPECIFIC_LOCATION(state, isSpecificLocation) {
            state.isSpecificLocation = isSpecificLocation;
        },
        SET_USER_DISTANCE(state, distance) {
            state.distance = distance;
            saveStateToLocalStore("radius", distance);
        },
        SET_USER_LOCATION(state, location) {
            state.userLocation = location;
            saveStateToLocalStore("lat", location.lat);
            saveStateToLocalStore("lng", location.lng);

        },
        SET_USER_SEARCH(state, location) {
            state.userSearch = location;
            saveStateToLocalStore("lat", location.lat);
            saveStateToLocalStore("lng", location.lng);
        }
    },
    getters: {
        filteredLocations(state) {
            return filterHours(
                filterByMeta(state.locations, state.filters.meta),
                state.filters.hours
            );
        },
        isInitializing(state) {
            return state.isInitializing;
        },
        isLoading(state) {
            return state.isLoading;
        },
        isSpecificLocation(state) {
            return state.isSpecificLocation;
        },
        selectedLocation(state) {
            return state.selectedLocation;
        },
        userDistance(state) {
            return state.distance;
        },
        userHours(state) {
            return state.filters.hours;
        },
        userLocation(state) {
            return state.userLocation;
        },
        userMeta(state) {
            return state.filters.meta;
        },
        userSearch(state) {
            return state.userSearch;
        }
    },
    actions: {
        geolocateUser: async ({ commit }) => {
            if (navigator.geolocation) {
                commit("SET_LOADING", true);
                await navigator.geolocation.getCurrentPosition(

                    position => {
                        let payload = {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude
                        };
                        commit("SET_USER_LOCATION", payload);
                        saveStateToLocalStore('term', undefined);
                    },
                    err => {
                        console.log("User did not allow geolocation, showing all locations");
                        commit("SET_USER_LOCATION", {});
                        console.log(err);
                    }
                );
            }
        },
        getSpecificLocation: async ({ commit, dispatch }, payload) => {
            commit("SET_LOADING", true);
            if (payload && payload.id) {
                try {
                    let { data } = await axios.get(
                        location_api.URI,
                        {
                            params: payload,
                            auth: location_api.auth
                        }
                    );

                    commit("SET_SELECTED_LOCATION", data);
                    commit("SET_LOADING", false);
                    commit("SET_INITIALIZING", false);
                } catch (e) {
                    console.log(e);
                }
            } else {
                dispatch("getLocations");
            }
        },
        getLocations({ commit, dispatch }, payload) {
            commit("SET_LOADING", true);

            let allPayload = {
                ...payload,
                radius: "all"
            };

            if (!isInRange(payload)) {
                console.log("User is not within Simmons service area, showing all locations");
                payload = allPayload;
            }
            else {
                payload = {
                    ...payload,
                    radius: defaultOpt.radius
                }
            }

            dispatch("updateLocations", payload);
            commit("SET_USER_DISTANCE", payload.radius);
            commit("SET_INITIALIZING", false);
        },
        updateDistance({ commit }, payload) {
            commit("SET_USER_DISTANCE", payload);
        },
        updateFilters({ commit }, payload) {
            commit("SET_FILTERS", payload);
        },
        updateIsInitializing({ commit }, payload) {
            commit("SET_INITIALIZING", payload);
        },
        updateIsSpecificLocation({ commit }, payload) {
            commit("SET_SPECIFIC_LOCATION", payload);
        },
        updateLocations: async ({ commit }, payload) => {
            commit("SET_LOADING", true);
            try {
                let { data } = await axios.get(
                    locations_api.URI,
                    {
                        params: payload,
                        auth: locations_api.auth
                    }
                );

                saveStateToLocalStore('lat', payload.lat);
                saveStateToLocalStore('lng', payload.lng);
                saveStateToLocalStore('radius', payload.radius);

                if (payload.term !== undefined) {
                    saveStateToLocalStore('term', payload.term);
                }

                commit("SET_LOCATIONS", data.locations);
                commit("SET_LOADING", false);
                commit("SET_INITIALIZING", false);
            } catch (e) {
                console.log(e);
            }
        },
        updateSelectedLocation({ commit }, payload) {
            commit("SET_SELECTED_LOCATION", payload);
        },
        updateUserSearch({ commit, dispatch }, payload) {
            commit("SET_USER_SEARCH", payload);
            dispatch("updateLocations", payload);
        },

    }
});
